// eslint-disable-next-line no-restricted-exports, unicorn/no-anonymous-default-export
export default (to: { matched: readonly unknown[] }) => to.matched.length === 0;
